import cn from "classnames";

import "./wire-widgets.scss";

/** Small coloured pill for an open request ("Pending" / "In Progress"). */
export const StatusPill = ({ progress }) =>
  progress === "in_progress" ? (
    <span className="widget-pill widget-pill-progress">In Progress</span>
  ) : (
    <span className="widget-pill widget-pill-pending">Pending</span>
  );

/**
 * Shared widget card: title (+ optional state text or pill), a body, and
 * bottom-aligned outlined actions. `actions` is an array of
 * { label, onClick, id?, disabled? }.
 */
const WireWidgetCard = ({ title, titleState, actions = [], className, children }) => (
  <div className={cn("wire-widget", className)}>
    <div className="wire-widget-head">
      <span className="wire-widget-title">{title}</span>
      {titleState && (
        <span className={cn("wire-widget-state", `is-${titleState.tone}`)}>
          {titleState.text}
        </span>
      )}
    </div>
    <div className="wire-widget-body">{children}</div>
    {actions.length > 0 && (
      <div className={cn("wire-widget-actions", { single: actions.length === 1 })}>
        {actions.map((a, i) => (
          <button
            key={a.id || i}
            type="button"
            id={a.id}
            className="wire-widget-btn"
            disabled={a.disabled}
            onClick={a.onClick}
          >
            {a.label}
          </button>
        ))}
      </div>
    )}
  </div>
);

export default WireWidgetCard;
